export const CASHOUT_ACTION_SET_STATE = 'CASHOUT_ACTION_SET_STATE'
export const CASHOUT_ACTION_SET_ORDER_CASHOUT = 'CASHOUT_ACTION_SET_ORDER_CASHOUT'
export const CASHOUT_ACTION_SET_ORDER_PARTIAL_CASHOUT = 'CASHOUT_ACTION_SET_ORDER_PARTIAL_CASHOUT'
export const CASHOUT_ACTION_SET_MIN_ORDER_CASHOUT = 'CASHOUT_ACTION_SET_MIN_ORDER_CASHOUT'
export const CASHOUT_ACTION_SET_MAX_ORDER_CASHOUT = 'CASHOUT_ACTION_SET_MAX_ORDER_CASHOUT'

export const orderCashoutWarningSmallAmount = 'order_cashout_warning_small_amount'
export const orderCashoutWarningBigAmount = 'order_cashout_warning_big_amount'
export const orderPartialCashoutWarningSmallAmount = 'order_partial_cashout_warning_small_amount'
export const orderPartialCashoutWarningBigAmount = 'order_partial_cashout_warning_big_amount'

export const ERROR_CASH_OUT_NOT_ALLOWED = 'CASH_OUT_NOT_ALLOWED'

export const orderCashoutTypes = {
  ORDER_CASHOUT_TYPE: 'CASH_OUT',
  ORDER_PARTIAL_CASHOUT_TYPE: 'PARTIAL_CASH_OUT'
}

export default {
  orderCashoutWarningSmallAmount,
  orderCashoutWarningBigAmount,
  orderPartialCashoutWarningSmallAmount,
  orderPartialCashoutWarningBigAmount,
  orderCashoutTypes
}
